import Counter from '../../../internal/platformMetrics/aggregators/Counter';
export const safeParams = [
    'stripelet_dashboard_page',
    'stripelet_dashboard_module',
    'stripelet_dashboard_workbench',
    'stripelet_unclassified'
];
export default new Counter('frontend.platform-ui.stripelet-count');

//# sourceMappingURL=stripeletCount.js.map